import { useNavigate } from "react-router-dom";

import { SubHeader } from "../StyledComponents/AppStyles";
import {
  ErrorSection,
  HeraldicPeopleError,
} from "../StyledComponents/ErrorStyles";

export default function ErrorPage({ resetStates }) {
  const navigate = useNavigate();

  const reset = () => {
    resetStates();
    navigate("/");
  };

  return (
    <ErrorSection>
      <SubHeader>
        <p>
          Welcome to the Heraldic Insurance portion of Indicio’s Banking
          verifiable credential demo. This is a mock website designed to show
          the process of using a credential across different websites.
        </p>
      </SubHeader>
      <div>
        <span>
          <HeraldicPeopleError />
        </span>
        <div>
          <h1>
            Oops! <span>Something went wrong.</span>
          </h1>
          <p>
            Sorry about that. <u onClick={reset}>Click here</u> to return to the
            previous page and try again.
          </p>
        </div>
      </div>
    </ErrorSection>
  );
}
